<template>
  <div class="card panel">
    <header class="card-header">
      <h3 class="card-header-title">
        {{ panel.place }}
      </h3>
      <a href="#" class="card-header-icon" aria-label="more options">
        <span class="icon">
          <i class="fas fa-angle-down" aria-hidden="true"></i>
        </span>
      </a>
    </header>
    <div class="card-content ml-5 mr-5">
      <div class="content has-text-left">
        {{message}}
        <div class="columns is-mobile">
          <div class="column">
            <h4>{{panel.date}}</h4>
            <h3>{{ panel.forecast}}</h3>
          </div>
          <div class="column ml-40">
            <span v-if="panel.image === 1"><img src="@/assets/images/slice1.png" width="100px"/></span>
            <span v-if="panel.image === 2"><img src="@/assets/images/slice2.png" width="100px"/></span>
            <span v-if="panel.image === 3"><img src="@/assets/images/slice3.png" width="100px"/></span>
          </div>
        </div>
        <p>{{panel.description}}</p>
        <div class="columns is-mobile">
          <div class="column">
            <p class="mb-20">
              夕焼け指数: {{  panel.per }}%<br>
              日の入り: {{panel.sunsetTime}}<br>
              角度: {{panel.sunAngle}}度
            </p>
          </div> 
          <div class="column compass mt-m10 ml-40"> 
            <img class="compass-component " src="@/assets/images/compass.png" width="100px"/>
            <img class="compass-component arrow  " :style="{transform: `rotate(${panel.sunAngle}deg)`}" src="@/assets/images/arrow.png" width="100px"/>
            <p class="updated has-text-grey"><small>{{panel.updated}}の気象図より</small></p>
          </div>
        </div>
      </div>
    </div>
    <!--
    <footer class="card-footer">
      <div class="card-footer-item">
        <div>

        </div>
      </div>
      <a href="#" class="card-footer-item"> Edit</a>
      <a href="#" class="card-footer-item">Delete</a>
    </footer>
    -->
  </div>
</template>

<script>
import predictMapper from "@/components/predictMapper"

export default {
  data () {
    return {
      msg: 'Welcome to Your Vue.js App Header',
      panel: {
        place: "Tokyo", date: " / ( )", sunAngle: 0, sunsetTime: "??", description: "データがありません" ,
        forecast: "取得中...", state: "エラー", updated: "?"
      },
      show: true
    }
  },
  props: ['message','day'],
  created() {
    this.findPanelForecast()
  }, 
  methods:{
    findPanelForecast(){ // jsonから指定された予測を取り出して表示 (prop.day,route.place)に依存
      const forecastData = require("../assets/js/forecasts.json")
      const now = new Date()
      // console.log(this.$route.params.place)
      if(this.$route.params.place !== undefined){
        this.panel.place = this.$route.params.place
      }
      // console.log(this.panel.place)
      this.panel.date = this.day

      const correspondingForecasts = forecastData.filter((fc)=> {
        return fc.place === this.panel.place
      }).filter((fc)=>{
        const predictTime = new Date(fc.predictTime)
        const predictDay = Math.floor((predictTime.getTime()+1000*60*60*9)/1000/60/60/24) //JST扱い
        const nowDay = Math.floor((now.getTime()+1000*60*60*9)/1000/60/60/24) // JST扱い
        const deltaTime =  predictDay - nowDay
        if(this.day === 'today'){
          return deltaTime == 0 // 同じ日を取り出し
        }else if(this.day === 'tomorrow'){
          return deltaTime == 1 // 次の日を取り出し
        }
      }).sort((fc_a,fc_b)=>{
        const fc_a_gribtime = new Date(fc_a.updated)
        const fc_b_gribtime = new Date(fc_b.updated)
        return fc_b_gribtime.getTime() - fc_a_gribtime.getTime() // 最終更新で並び替え
      })
      const forecast = correspondingForecasts[0]
      if(forecast == null){
         this.panel.forecast = ""
         this.panel.description = "データが見つかりません"
        return 
      }
      const predict = predictMapper(forecast.predicts)
      
      const pt = new Date(forecast.predictTime)
      const weekAssign = ["日","月","火","水","木","金","土"]
      const weekday = weekAssign[pt.getDay()]
      const dateStr = `${pt.getMonth()+1}/${pt.getDate()}(${weekday})`

      const kanjiDict = {'Nagoya': '名古屋', 'Tokyo': '東京', 'Osaka': '大阪'}
      this.panel.place = kanjiDict[forecast.place]
      this.panel.date = dateStr
      this.panel.forecast = predict.text
      this.panel.description = predict.description
      this.panel.sunsetTime = forecast.sunsetTime
      this.panel.sunAngle = Math.round(forecast.sunAngle * 10) / 10 
      this.panel.per = predict.per
      this.panel.image = predict.image
      const gribTime = new Date(forecast.gribTimeUTC).getTime() +1000*60*60*9 
      const gd = new Date(gribTime)
      this.panel.updated = `${gd.getMonth()+1}/${gd.getDate()} ${gd.getHours()}:00`
    },
  },
  watch: {
    '$route' (to, from) {
      // ルートの変更の検知...
      // this.findPanelForecast()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.panel{
  background: rgba(255,255,255,0.9)
}


.compass {
    position: relative;
    opacity: 0.7
} 
.compass-component {
  position: absolute;
}

.arrow {
  animation: r1 .7s;
}
@keyframes r1 {
  0%   { transform: rotate(90deg); }
}

.updated{
  position: relative;
  font-size:12px;
  left:20px;
  top: 94px;
}

@media screen and (max-width: 550px) {
  p{
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ForecastPanel.vue